import React, { useContext } from 'react';
import InputBase from '../InputBase';
import MuiTooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core';
import { FormContext } from '../FormContext';

const Tooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#fff',
    borderRadius: 8,
    border: '1px solid #c4c4c4',
    color: '#000'
  }
}))(MuiTooltip);

const LinkFieldView = props => {
  const { validateField } = useContext(FormContext);
  return props.isAdmin ? (
    <Tooltip
      leaveDelay={1000}
      interactive
      title={
        <div>
          Go to link:{' '}
          <a href={props.value || ''} target="_blank">
            {props.value}
          </a>
        </div>
      }
    >
      <div>
        <InputBase
          id={props.internalId}
          variant="outlined"
          value={props.value || ''}
          onChange={props.onValueChange}
          inputProps={{ readOnly: props.readOnly, 'data-lpignore': 'true' }}
          {...props.muiInputProps}
        />
      </div>
    </Tooltip>
  ) : (
    <div>
      <a href={props.value} target="_blank">
        {props.value}
      </a>
    </div>
  );
};

export default LinkFieldView;
